module.exports = {"pageTitleText":"憑證申請","serverName":"域名","sslProvider":"SSL憑證供應商","queues":"佇列","fastEntry":"快速通道","cnameAllowList":"白名單","success":"成功","black":"黑名單","objId":"物件 ID","requestSSLState":"申請狀態","collectSSLState":"收集狀態","addToQueueDate":"新增至佇列的時間","taskAction":"操作名稱","requestAttemptCount":"申請次數","requestSSLDate":"申請日期","requestSSLErrMsg":"申請錯誤訊息","requestSSLOrderNumber":"申請編號","requestSSLlValidateFileName":"申請驗證檔名","collectAttemptCount":"收集次數","collectSSLDate":"收集日期","collectSSLErrMsg":"收集錯誤訊息","certkeyRaw":"憑證","certpemRaw":"私鑰","queueState":"佇列狀態"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/certsapply.json
// module id = CtWh
// module chunks = 3